export default __webpack_public_path__ + "static/media/Launching-pana.02734a67.svg";